import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const HowItWorks = () => {
  const steps = [
    {
      icon: FiIcons.FiUserPlus,
      title: "A visitor lands on your booking page."
    },
    {
      icon: FiIcons.FiMousePointer,
      title: "They click 'Talk To Us Live' instead of filling out a form."
    },
    {
      icon: FiIcons.FiVideo,
      title: "An AgentOnDemand agent appears instantly, ready to help."
    },
    {
      icon: FiIcons.FiCalendar,
      title: "The agent answers questions, builds trust, and books the appointment straight into your calendar."
    }
  ];

  return (
    <section className="py-24 bg-navy-light border-y border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-5xl font-anton uppercase tracking-wide text-white">
            How It <span className="text-gold">Works</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative">
          <div className="hidden md:block absolute top-[44px] left-[12%] right-[12%] h-[2px] bg-white/10 z-0"></div>

          {steps.map((step, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
              className="relative z-10 flex flex-col items-center text-center"
            >
              <div className="w-24 h-24 rounded-full bg-navy border-4 border-navy-light flex items-center justify-center mb-6 shadow-xl relative group">
                <div className="absolute inset-0 rounded-full bg-gold/5 group-hover:bg-gold/20 transition-colors"></div>
                <SafeIcon icon={step.icon} className="text-3xl text-gold" />
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gold text-navy font-bold flex items-center justify-center text-sm border-2 border-navy">
                  {index + 1}
                </div>
              </div>
              
              <p className="text-lg text-gray-300 font-medium max-w-[250px]">
                {step.title}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;